// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconbutton[data-v-01200ffe]:hover{cursor:pointer}.iconimage[data-v-01200ffe]{width:17px}", ""]);
// Exports
module.exports = exports;
